import SearchIcon from "@mui/icons-material/Search"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import React, { useState } from "react"
import type { Control, FieldValues } from "react-hook-form"
import { Controller } from "react-hook-form"

import { TextInputProps } from "@components/text_input/sub_components/primary_input"
import { CHECKBOX_BORDER_COLOR } from "@constants/colors"

import styles from "./styles"

export default function SearchInput<T extends FieldValues, K = unknown>(
  props: TextInputProps<T, K>
) {
  const [isFocus, setIsFocus] = useState(false)

  function handleOnFocus(
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) {
    if (e.target.value === "") {
      setIsFocus(false)
    }
    setIsFocus(true)
    props?.onFocus && props?.onFocus(e)
  }

  function handleOnBlur(
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) {
    setIsFocus(false)
    props?.onBlur && props?.onBlur(e)
  }

  return (
    <Box sx={styles.container}>
      <Controller<FieldValues>
        name={props.name}
        control={props.control as unknown as Control<FieldValues>}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            helperText={error ? error.message : null}
            error={!!error}
            onChange={onChange}
            value={value as FieldValues}
            focused={isFocus}
            fullWidth
            variant="outlined"
            onBlur={handleOnBlur}
            onFocus={handleOnFocus}
            {...props}
            InputProps={{
              startAdornment: isFocus ? null : (
                <SearchIcon sx={{ color: "#9B9B9B" }} />
              )
            }}
            sx={{
              " input": {
                padding: "7px 14px 7px 14px!important"
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: CHECKBOX_BORDER_COLOR,
                  borderRadius: "0.5rem"
                }
              }
            }}
            label={undefined}
          />
        )}
      />
    </Box>
  )
}
